<template lang="pug">
el-tooltip(
    :content="$t('The price depends on the settings chosen for each generation. Expand the row to see the individual charges.')"
    placement="top"
)
    span.metered-unit-price {{ $t('varies') }}
</template>

<i18n>
{
    "de": {
        "varies": "variabel",
        "The price depends on the settings chosen for each generation. Expand the row to see the individual charges.": "Der Preis hängt von den gewählten Einstellungen der jeweiligen Generierung ab. Zeile ausklappen, um die einzelnen Positionen zu sehen."
    }
}
</i18n>

<script>
/**
 * Stands in for the Unit price cell of a metered line item.
 *
 * Such a line has no single unit price — every run costs what the provider charged
 * for it, and the stored `unit_price` is only total / quantity. Printing that number
 * would imply `total = quantity x unit price`, which is exactly what is not true.
 */
export default {
    name: 'MeteredUnitPrice',
};
</script>

<style lang="sass" scoped>
.metered-unit-price
    color: #6b7280
    font-style: italic
    cursor: help
</style>
